module.exports = __webpack_public_path__ + "static/media/_MIC2644.image.efd9a339.png";